<template>
  <v-main>
    <v-app-bar
      color="#294A66"
      dark height="50px"
      style="position:fixed; top:0; z-index:10;"
    >
      <v-toolbar-title v-text="aboutLid.title" v-if="aboutLid" class="mx-auto mb-0"> </v-toolbar-title>
    </v-app-bar>
    <router-view :key="$route.fullPath" style="margin-top: 50px;"
    ></router-view>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      style="background-color:#DCDCDC; z-index:20;"
    >
      <navi></navi>
    </v-navigation-drawer> 

    <div style="position:fixed;bottom:10vh;width:100%;">
      <div class="d-flex aling-center">
        <v-chip v-if="$route.name!=='sp_content'" class="mx-auto ink--text" color="white" large style="border:medium solid #2b2b2b !important" @click="$router.push('/sp/'+$route.params.id+'/content')">
          前提情報を見る
        </v-chip>
        <v-chip v-if="$route.name!=='sp_idea'" class="mx-auto deepAqua--text" color="white" large style="border:medium solid #008CFF !important" @click="$router.push('/sp/'+$route.params.id+'/idea')">
          アイデアを見る/投稿
        </v-chip>
        <v-chip v-if="$route.name!=='sp_project'" class="mx-auto deepAlgae--text" color="white" large style="border:medium solid #399942 !important" @click="$router.push('/sp/'+$route.params.id+'/project')">
          プロジェクトを見る
        </v-chip>
      </div>

    </div>   
  
    <div style="position:fixed;bottom:0px;width:100%;">
      <v-system-bar class="text-center" color="faintHoney" style="width:100% !important;" v-if="!isAuthed">
        <p class="mb-0 mx-auto">現在未ログインです。<v-btn class="py-0" text @click="authModal=true" style="text-decoration: underline; color:#008CFF;">ログイン</v-btn></p>
      </v-system-bar>
      <v-system-bar class="text-center" color="faintHoney" style="width:100% !important;" v-else-if="aboutLid&&!(aboutLid.sanka)">
        <p class="mb-0 mx-auto">現在このLidに参加していません。<v-btn class="py-0" text style="text-decoration: underline; color:#008CFF;" @click="LidSankaAlert=true">参加</v-btn>しますか?</p>
      </v-system-bar>
      <v-bottom-navigation
        grow
        :value="1"
      >
        <v-btn @click="drawer = !drawer">
          <span>メニュー</span>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
  
        <router-link to="/sp_home" style="text-decoration: none;" class="my-auto">
          <v-btn>
              <span>トップ</span>
              <v-icon>mdi-home</v-icon>
          </v-btn>
          </router-link>

        <v-btn @click="notify=true">
          <span>通知</span>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </v-bottom-navigation>    
    </div>


    <!--通知画面-->
    <v-dialog fullscreen v-model="notify" class="pa-0">
      <notifySp @close="closeNotify()"></notifySp>
    </v-dialog>

    <!--サインイン画面-->
    <v-dialog fullscreen v-model="authModal">
      <auth-view
        defaultView="chooseauth"
        @closeModal="closeAuthModal"
      >
      </auth-view>
    </v-dialog>

    <!--Lid参加確認画面-->
    <v-dialog v-model="LidSankaAlert" width="800">
      <v-card color="white" elevation="15" class="pt-6">
        <v-card-actions class="d-flex justify-center align-center">
          <v-img class="mr-4" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
          <div>
            <p class="font-weight-bold text-h5 text-center">あなたはこのLidに参加していません。</p>
            <p class="font-weight-bold text-h5 text-center mb-0">このLidに参加しますか？</p>        
          </div>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
          <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, $store.dispatch('inLid',{lidId:$route.params.id,uid:uid})" color="deepAqua" dark>参加</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="card_lidsanka" width="600px">
      <v-card class="pa-2 d-flex flex-column" height="200px">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="card_lidsanka=false">
            <v-icon color="#E64550">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-center ink--text my-auto" style="font-size:25px;">Lidに参加しました</v-card-text>
        <v-card-actions class="mt-auto">
          <v-spacer></v-spacer>
          <v-chip class="deepAqua white--text" @click="card_lidsanka=false">確認</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
  
<script>
import Vue from 'vue'
import firebase from 'firebase'
import navi from './sp_navigator.vue'
import notifySp from './sp_notification.vue'
import authView from '../../components/auth/authView.vue';
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'sp' // customize this for SSR
})
export default {
  components: {
    notifySp,
    navi,
    authView
  },
  data: () => ({
    drawer: false,
    notify: false,
    authModal: false,
    LidSankaAlert: false,
    card_lidsanka: false
  }),
  created(){
  },
  mounted(){
    if(this.$mq === 'pc'){
      this.$router.push('/lid/'+this.$route.path.split('/').slice(2).join('/'))
    }
    if (this.lid != null) {
      this.$store.dispatch('getAboutLid', this.$route.params.id)
    }
  },
  watch: {
    $route() {
      if (this.lid != null) {
        this.$store.dispatch('getAboutLid', this.$route.params.id)
      }
    },
    lid() {
      if (this.lid != null) {
        this.$store.dispatch('getAboutLid', this.$route.params.id)
      }
    },
  },
  computed: {
    members(){
      return this.$store.state.members
    },
    namelist(el){
      return this.$store.state.namelist
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    lidusers(){
      return this.$store.state.lidusers
    },
    getSelectColor() {
      return this.inspirecolor(this.postcolor);
    },
    aboutLid() {
      return this.$store.state.aboutLid;
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
  },
  methods: {
    closeNotify(){
      this.notify = false
    },
    closeAuthModal() {
      this.authModal = false
    },
  },
}
</script>
<style>
  .listgroup >>> .v-list-item__icon{
      margin: 0px !important;
  }
  .listgroup >>> .v-list-group__header__prepend-icon{
      padding-top: 7% !important;
      padding-right: 4% !important;
      margin-right: 1% !important;
  }
  .step{
    list-style-type: none;
    display:table;
    width:100%;
    height:45px;
    padding:0;
    margin:0;
    overflow:hidden;
  }
  .step li{
    display:table-cell;
    width:10%;
    position:relative;
    background: #DCDCDC;
    padding: 1em 0.5em 1em 2em;
    color: #707070;
  }
  .step li:last-child{
    padding-right: 1em;
  }
  .step li:last-child:before,
  .step li:last-child:after{
    display:none;
  }
  .step li:before,
  .step li:after{
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin: auto;
  }
  .step li:before{
    top:-15px;
    right:-1em;
    border-style: solid;
    border-color: transparent transparent transparent #fff;
    border-width: 40px 0 40px 1em;
    z-index: 5;
  }
  .step li:after{
    top:-15px;
    right:-.8em;
    border-style: solid;
    border-color: transparent transparent transparent #DCDCDC;
    border-width: 40px 0 40px 1em;
    z-index: 5;
  }
  .step li.current{
    background: #fff;
    color: #2B2B2B;
    font-weight: bold;
  }
  .step li.current:after{
    border-color: transparent transparent transparent #fff;
  }
  *{
    font-family:mplus-2c-medium;
  }
  </style>